// xNotify chart styling DNA — mirrors src/pages/DashboardComponents/Charts/*
// (the rest of the portal's Highcharts charts): Inter font, no credits,
// dotted gridlines, rounded data-labelled columns, shared brand palette, HTML
// tooltips. Keeps the Smart Links charts visually identical to the rest of the
// app so the Link Detail page doesn't look like a different product.

export const CHART_FONT = 'Inter, sans-serif';

// Same hues the dashboard charts use (#10b981 green, #3b82f6 blue, #f59e0b
// amber, var(--brand-primary) indigo brand, #ef4444 red, #8b5cf6 purple…) — indigo first
// so single-series charts lead with the brand colour.
export const BRAND_COLORS = [
  'var(--brand-primary)', '#10b981', '#f59e0b', '#3b82f6', '#ef4444',
  '#8b5cf6', 'var(--brand-primary)', '#ec4899', '#22c55e', '#9e9e9e',
];

// 11px / 600 / slate — the exact data-label style ChannelPerformanceChart uses.
export const DATA_LABEL_STYLE = {
  fontSize: '11px',
  fontWeight: '600',
  color: '#374151',
  textOutline: 'none',
} as const;

export const AXIS_LABEL_STYLE = { fontSize: '11px', color: '#6b7280' } as const;
export const GRID_COLOR = '#e5e7eb';

/** Compact integer label for axes / data labels / tooltips. */
export const fmt = (n: number): string => Number(n || 0).toLocaleString();
